// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__Kkn1j","calendarButtons":"ClockData_calendarButtons__1OPbr"};